var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var g0 = _vm.status === 0 ? _vm.shopList && _vm.shopList.length > 0 : null
  var l1 =
    _vm.status === 0 && g0
      ? _vm.__map(_vm.shopList, function (item, index) {
          var $orig = _vm.__get_orig(item)
          var m0 = _vm.stringOperations(item.categoryName, 4)
          var m1 = _vm.stringOperations(item.brandName, 4)
          var m2 = _vm.stringOperations(item.name, 16)
          var l0 = _vm.__map(item.xhData, function (data, s) {
            var $orig = _vm.__get_orig(data)
            var m3 = _vm.stringOperations(data.name, 7)
            return {
              $orig: $orig,
              m3: m3,
            }
          })
          return {
            $orig: $orig,
            m0: m0,
            m1: m1,
            m2: m2,
            l0: l0,
          }
        })
      : null
  var m4 = _vm.status === 0 && g0 ? _vm.simplifyNum(_vm.zdj) : null
  var m5 = _vm.status === 0 && g0 ? _vm.simplifyNum(_vm.totalPrices) : null
  var g1 =
    _vm.status === 1 || _vm.status === 2 ? _vm.attrFirstList.length : null
  var g2 =
    _vm.status === 1 || _vm.status === 2 ? _vm.attrSecondList.length : null
  var g3 = _vm.status === 1 || _vm.status === 2 ? _vm.budgetList.length : null
  var g4 = _vm.status === 1 || _vm.status === 2 ? _vm.brandData.length : null
  var g5 =
    (_vm.status === 1 || _vm.status === 2) && (_vm.isPK || _vm.status === 2)
      ? JSON.stringify(_vm.leftShop)
      : null
  var m6 =
    (_vm.status === 1 || _vm.status === 2) &&
    (_vm.isPK || _vm.status === 2) &&
    !(g5 == "{}")
      ? _vm.stringOperations(_vm.leftShop.name, 14)
      : null
  var g6 =
    (_vm.status === 1 || _vm.status === 2) && (_vm.isPK || _vm.status === 2)
      ? JSON.stringify(_vm.rightShop)
      : null
  var m7 =
    (_vm.status === 1 || _vm.status === 2) &&
    (_vm.isPK || _vm.status === 2) &&
    !(g6 == "{}")
      ? _vm.stringOperations(_vm.rightShop.name, 14)
      : null
  var l2 =
    (_vm.status === 1 || _vm.status === 2) && _vm.isPK && _vm.pkcontent
      ? _vm.__map([_vm.leftShop, _vm.rightShop], function (item, index) {
          var $orig = _vm.__get_orig(item)
          var m8 = _vm.stringOperations(item.name, 30)
          return {
            $orig: $orig,
            m8: m8,
          }
        })
      : null
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        g0: g0,
        l1: l1,
        m4: m4,
        m5: m5,
        g1: g1,
        g2: g2,
        g3: g3,
        g4: g4,
        g5: g5,
        m6: m6,
        g6: g6,
        m7: m7,
        l2: l2,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }